import { linkToPatient } from "$routes/patient/links";

export function linkToPatientCreateANC() {
  return `${linkToPatientANC()}/new`;
}

function linkToPatientANC() {
  return `${linkToPatient()}/antenatal-care`;
}

export function linkToPatientANCEncounter(id = ":encounterId") {
  return `${linkToPatientANC()}/${id}`;
}
